<baugeraete-header></baugeraete-header>
<vhv-sidebar></vhv-sidebar>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<baugeraete-modal-area></baugeraete-modal-area>
<div class="versionsnummer" style="left: auto; right: 0;">Version {{version}}</div>
